import styled from '@emotion/styled';
import { Button, Divider, Table } from 'antd';
import { useEffect, useState } from 'react';
import { YELLOW } from '../../../shared/colors';

const Container = styled.div`
  th {
    background-color: ${YELLOW} !important;
    color: white !important;
    font-weight: bold;
  }

  .style-row {
    font-family: Poppins-L;
    color: black;

    &:hover > td {
      background-color: #bdbdbd !important;
      cursor: pointer;
    }
  }

  .even {
    background-color: #eee;
  }

  .ant-table.ant-table-small .ant-table-tbody > tr > td {
    padding: 2px 5px;
  }

  > .picker {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    width: 100%;
    margin-bottom: 10px;
  }

  .form-control-lg {
    min-height: 36px;
    min-width: 240px;
    padding: 6px 10px;
  }

  @media (max-width: 767px) {
    h2 {
      font-size: 20px;
    }

    > .picker {
      align-items: stretch;
      flex-direction: column;
    }

    .form-control-lg {
      min-width: 0;
      width: 100%;
    }
  }
`;

export const RegPays = () => {
  const [reglements, setReglements] = useState<any[]>([]);
  const [filterReglements, setFilterReglements] = useState<any[]>([]);
  const [selectData, setSelectData] = useState('');

  useEffect(() => {
    setReglements(REGLEMENTS);
    setFilterReglements(REGLEMENTS);
  }, []);

  const filter = () => {
    if (selectData) {
      setFilterReglements(
        reglements.filter((ac) => {
          console.log(selectData, reglements, ac.titre.includes(selectData));
          if (ac.titre.includes(selectData) > -1) {
            return true;
          }
          return false;
        }),
      );
    }
  };

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSelectData(value);
  };
  const COLUMNS = [
    {
      title: 'Thème',
      dataIndex: 'theme',
      width: 400,
    },
    {
      title: 'Titre du document',
      dataIndex: 'titre',
      render: (cell: any, row: any) => (
        <span onClick={() => window.open(row.link, '_blank')}>{cell}</span>
      ),
      width: 1300,
    },
    {
      title: 'Taille',
      dataIndex: 'taille',
      width: 200,
    },
    {
      title: 'Pays',
      dataIndex: 'pays',
      width: 200,
    },
    {
      title: 'Année',
      dataIndex: 'annee',
      width: 200,
    },
  ];

  return (
    <Container>
      <h2>RÈGLEMENTS PAR PAYS</h2>
      <Divider style={{ backgroundColor: 'orange', marginBottom: 10 }} />
      <div className='picker'>
        <input
          className='form-control-lg'
          placeholder='Rechercher'
          type='text'
          onChange={handleInput}
        />
        <Button className='butt' onClick={filter}>
          Valider
        </Button>
      </div>

      <div></div>
      <Table
        columns={COLUMNS}
        dataSource={filterReglements}
        rowClassName={(row, index) =>
          index % 2 === 0 ? 'style-row even' : 'style-row'
        }
        scroll={{ x: 1000 }}
        size='small'
        // style={{ zoom: 1 }}
        // pagination={false}
      />
    </Container>
  );
};

const REGLEMENTS = [
  {
    theme: 'Marché des Titres Publics ',
    titre:
      "Document d'information relatif aux émissions des Obligations du Trésor Assimilables (OTA) par l'Etat du Cameroun - Exercice 2020",
    taille: '2 MB',
    pays: 'Cameroun',
    annee: '2020',
    link: 'https://www.beac.int/wp-content/uploads/2020/04/Note-dInformations-OTA-2020-final-publi%C3%A9.pdf',
  },
  {
    theme: 'Marché des Titres Publics ',
    titre:
      'Information document related to issuance of fungible treasury titres through bid invitation by the State of Cameroon - 2020 financial year',
    taille: '2 MB',
    pays: 'Cameroun',
    annee: '2020',
    link: 'https://www.beac.int/wp-content/uploads/2020/04/Information-Note-OTA-2020-Anglais-final.pdf',
  },
];
